import { AutoBucketHistory, BucketStrategy, TimeBucketUnits } from '@iotv/datamodel-core';
import { isNonNaNNumber, SortOrder } from '@iotv/iotv-v3-types';
import { ObservationInputMetaKeys } from '../fns';
const debug = process.env.REACT_APP_DEBUG && true;
const defaultTimeBucketDef = {
    unit: TimeBucketUnits.MINUTE,
    width: 5,
};
export const matchViaBuckets = ({ timeBucketDef = defaultTimeBucketDef, recentStateHistory, observationHistory, actualReadingPrefix, bucketStrategyMap, }) => {
    const autoBucketHistory = new AutoBucketHistory({ timeBucketDef, bucketStrategyMap, defaultBucketStrategy: BucketStrategy.INFERREADING });
    if (recentStateHistory && observationHistory) {
        const firstTimestampMs = observationHistory.observedHistory.getFirstTimestamp();
        const lastTimestampMs = observationHistory.observedHistory.lastTimestamp();
        if (isNonNaNNumber(firstTimestampMs) && isNonNaNNumber(lastTimestampMs)) {
            const observationHistorySnapshotArray = observationHistory.observedHistory.getStateSnapshotArray(SortOrder.ASCENDING);
            const observationHistoryLength = observationHistorySnapshotArray.length;
            if (observationHistoryLength > 0) {
                const firstObservationPeriodStart = observationHistorySnapshotArray.at(0)?.state.fromTimestampMs ?? 0;
                const lastObservationPeriodEnd = observationHistorySnapshotArray.at(observationHistoryLength - 1)?.state.toTimestampMs ?? 0;
                const recentStateHistorySlice = recentStateHistory.sliceByTimestamp([firstObservationPeriodStart, lastObservationPeriodEnd]);
                const recentStateSnapshotArray = recentStateHistorySlice.getStateSnapshotArray(SortOrder.ASCENDING);
                const observationKeys = observationHistory.observedHistory.keys().filter((k) => !ObservationInputMetaKeys.includes(k));
                const matchedKeys = recentStateHistory.keys().filter((k) => observationKeys.includes(k));
                matchedKeys.forEach((k) => {
                    const acutalKey = `${actualReadingPrefix}${k}`;
                    autoBucketHistory.setKeyStrategy(acutalKey, bucketStrategyMap?.[k] ?? BucketStrategy.INFERREADING);
                });
                recentStateSnapshotArray.forEach((snapshot) => {
                    const timestamp = snapshot.timestamp;
                    const state = Object.fromEntries(matchedKeys.map((k) => [`${actualReadingPrefix}${k}`, snapshot.state[k] ?? null]));
                    autoBucketHistory.push({ timestamp, state });
                });
                observationHistorySnapshotArray.forEach((snapshot) => {
                    const { fromTimestampMs, toTimestampMs } = snapshot.state;
                    const timestamp = (fromTimestampMs + toTimestampMs) / 2; // using mid point of observation period as timestamp for matching
                    const state = Object.fromEntries(matchedKeys.map((k) => [k, snapshot.state[k] ?? null]));
                    autoBucketHistory.push({ timestamp, state });
                });
            }
        }
    }
    return autoBucketHistory;
};
